module.exports = __webpack_public_path__ + "static/media/presignup.b176f3a1.png";